import BillingTransactionTypeFacetDetails from './BillingTransactionTypeFacetDetails';
import { billingTransactionTypeTag } from './tag';
import { makeCriteriaProvider } from './enhancers';

export default {
  makeCriteriaProvider,
  tag: billingTransactionTypeTag,
  DetailsControl: BillingTransactionTypeFacetDetails
};
